import { formatAnalyticsSource } from '@/helpers/common';

export function getToolAnalyticsPaywallType(
  toolType?: string | null
): string | undefined {
  if (!toolType) {
    return undefined;
  }

  return `premium_download_${formatAnalyticsSource(toolType)}`;
}

export function resolveAnalyticsPaywallType({
  paywallType,
  toolType,
  fallback = 'in_app',
}: {
  paywallType?: string | null;
  toolType?: string | null;
  fallback?: string;
}): string {
  return paywallType ?? getToolAnalyticsPaywallType(toolType) ?? fallback;
}
